import { render, staticRenderFns } from "./TelInput.vue?vue&type=template&id=6d06d798&"
import script from "./TelInput.vue?vue&type=script&lang=ts&"
export * from "./TelInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports